import Icon from '../components/Icon.vue'

Icon.register({"folder-plus":{"width":512,"height":512,"paths":[{"d":"M464 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128zM368 296C368 304.8 360.8 312 352 312H280V384C280 392.8 272.8 400 264 400H248C239.2 400 232 392.8 232 384V312H160C151.2 312 144 304.8 144 296V280C144 271.2 151.2 264 160 264H232V192C232 183.2 239.2 176 248 176H264C272.8 176 280 183.2 280 192V264H352C360.8 264 368 271.2 368 280V296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/folder-plus.js
// module id = null
// module chunks = 